export default __webpack_public_path__ + "static/media/sticker-p.936b6d51.png";